import React, { useState, useEffect } from 'react';

// Import CSS & assets
import ico_map_layers from '../../../../assets/ico/ico_map_layers.svg';


const ZoneUrba = ({ zoneUrba_data, mapShow_change, zoneUrba_mapShow }) => {

    return (
        <div className="app__ruleset_zoneUrba2_container_main">
            <div className="app__ruleset_zoneUrba2_container_left">
                <div className="app__ruleset_document_title_small" style={{ marginBottom: "4px" }}>{zoneUrba_data?.properties?.libelle || "Libellé de la zone"}</div>
                <div className="app__ruleset_document_description_small">{zoneUrba_data?.properties?.libelong || "Description de la zone"}</div>
            </div>
            <div className="app__ruleset_zoneUrba2_container_right">
                <div className="app__sectiondata_widget_layer">
                    <img src={ico_map_layers} alt="ico_map_layers" />
                    <div className="app__map_layer_checkbox"><input className="app__map_layer_checkbox_element" type="checkbox" id={"sectiondata_switch_highlightedRule_" + zoneUrba_data?.properties?.id} checked={zoneUrba_mapShow.includes(zoneUrba_data?.properties?.id) ? true : false} onChange={() => { mapShow_change(zoneUrba_data?.properties?.id) }} /><label className={`app__map_layer_checkbox_label ${zoneUrba_data?.geometry?.type === "MultiPolygon" ? "" : "app__ruleset_zoneUrba2_mapcheckbox_hidden"}`} htmlFor={"sectiondata_switch_highlightedRule_" + zoneUrba_data?.properties?.id}>Toggle</label></div>
                </div>
            </div>
        </div>
    );
};

export default ZoneUrba;